export function modelResponse({ data, trackingId }, modelCallback) {
    const modeledResponse = modelCallback ? modelCallback(data) : { ...data };
    modeledResponse.getTrackingId = () => trackingId || null;

    return modeledResponse;
}
